module.exports = __webpack_public_path__ + "static/media/logo_ferrara_feelings.8da33b37.webp";